import { defHttp } from '/@/utils/http/axios';
import { dateUtil } from '/@/utils/dateUtil';
import { Modal } from "ant-design-vue";
import { createVNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

enum Api {
  getProjectInfo = '/prj/projectInfo/',
  projectBaseInfo = '/prj/projectInfo/baseInfo',
  rejectProject = '/prj/projectInfo/reject',
  confirmProject = '/prj/projectInfo/confirm',
  newConfirmProject = '/prj/projectInfo/complete',
  listProject = '/prj/projectInfo/list',
  getAttachments = '/spp/attachmentInfo/list',
  getPlanByPrjId = '/prj/planInfo/getInfoByPrjId',
  fileToBase64 = '/storage/file/fileToBase64',
  deletePrj = '/prj/projectInfo/delete',
  deleteProject = '/prj/projectInfo/remove',
  checkDeleteAllowApi = '/prj/projectInfo/remove/check',
  copyPrj = '/prj/projectInfo/copy',
  sysAreaList = '/sys/sysArea/list',
  enterpriseList = '/prj/projectInfo/getEnterpriseInfo',
  enterpriseInfoWithSub = '/prj/projectInfo/getEnterpriseInfoWithSub',
  enterpriseInfoWithSubById = '/prj/projectInfo/getEnterpriseInfoWithSubById',
  handShakingEnterpriseList = '/prj/projectInfo/getInitiators',
  serverList = '/crm/sysServerInfo/queryServerList',
  createPrj = '/spp/project/create',
  serverInfo = '/crm/sysServerInfo/getServerInfo',
  getPrjCode = '/spp/code/generator',
  addPrjStep1 = '/prj/projectInfo/addFirstStep',
  addPrjStep2 = '/prj/projectInfo/addSecondStep',
  getPrjPermision = '/prj/projectInfo/workflow/',
  savePrj = '/prj/planInfo/edit',
  submitPrj = '/prj/planInfo/insideSubmit',
  lockPrjStatementInfo = '/prj/projectInfo/lockPrjStatementInfo',
  unLockPrjStatementInfo = '/prj/projectInfo/unLockPrjStatementInfo',
  projectDeliveryInfo = '/spp/statementInfo/getStatementByPrjId',
  createStatementInfo = '/spp/statementInfo/createStatementInfo',
  queryAllStatement = '/spp/statementInfo/queryAllStatement',
  queryDeliveryListByStatement = '/spp/statementInfoNew/queryDeliveryListByStatement',
  queryStatementByDoctorPage = '/spp/statementInfoNew/queryStatementByDoctorPage',
  queryStatementByOutsourcerPage = '/spp/statementInfoNew/queryStatementByOutsourcerPage',
  submitStatements = '/spp/statementInfo/confirmStatement',
  updateDeliveryCount = '/spp/statementInfo/updateDeliveryCount',
  getDeliveryAmount = '/spp/statementInfo/queryTotalAmountByStatementCount',
  getServerUserData = '/sys/user/queryByServerId',
  deliveryCalculateRule = '/spp/statementInfo/queryAllCalculationFormula',
  enterpriseTaxList = '/spp/statementInfo/enterpriseTaxList',
  fillEnterpriseTaxInfo = '/spp/statementInfo/fillEnterpriseTaxInfo',
  exportVisitData = '/prj/projectInfo/exportVisitData',
  initiatorManagerApi = '/spp/industrial/projectInfo/getUsers',
  industrialDeliveryCount = '/spp/industrial/task/deliveryCount',
  changeInitiatorManagerApi = '/prj/projectInfo/editProjectInitiator',
  addPrjManagerApi = '/prj/projectManager/addManager',
  prjManagerUserRoleListApi = '/prj/projectManager/userRoleList',
  deletePrjManagerApi = '/prj/projectManager/deleteManager',
  deletePrjManagerBatchApi = '/prj/projectManager/deleteManagerBatch',
  queryPrjManagerFunApi = '/prj/projectManager/queryManagerFun',
  addPrjManagerFunApi = '/prj/projectManager/addManagerFun',
  queryPrjManagerDataRoleApi = '/prj/projectManager/queryManagerDataRole',
  addPrjManagerDataRoleApi = '/prj/projectManager/addManagerDataRole',
  myPrjAuthListApi = '/prj/projectManager/myAuthList',
  getPrjSettingApi = '/prj/projectAutoRule/',
  savePrjSettingApi = '/prj/projectAutoRule/saveBatchProjectAutoRule',
  getPrjAmountFetchApi = '/prj/projectAutoRule/queryDeliveryTotalAmount',
  getPrjFieldDisableApi = '/spp/fieldEditable/listFieldEditable',
  getPrjEntityDataLogApi = '/spp/dataOperationLog/list',
  deliveryListNum = '/spp/statementDetails/queryStatementPopDelivery',
  deliveryListAmount = '/spp/statementDetails/updateStatementPopDelivery',
  updateDeliveryListCount = '/spp/statementDetails/updateStatementPopDeliveryCount',
  deliveryPriceRange = '/spp/paymentTaskPrice/queryPriceList',
  deliveryPriceCheck= '/spp/paymentTaskPrice/checkPriceRange',
  deliveryActualUnitPriceCheck= '/spp/paymentTaskPrice/checkPurchasePriceEdit',
  updateDeliveryPrice = '/spp/statementInfo/editStatementDeliveryUnitPrice',
  queryDeliveryCountByFilter = '/spp/statementInfoNew/queryDeliveryCountByFilter',
  updateDeliveryCountByFilter = '/spp/statementInfoNew/updateDeliveryCountByFilter',
  updateMeetingDeliveryPrice = '/spp/statementInfo/editStatementMeetingUnitPrice',
  meetingExecutorPrice = '/spp/statementInfo/queryUnitPriceByObjId',
  importProjectAutoRuleApi = '/spp/asyncTask/projectAutoRule/import',
  getAutoRuleTemplateUrlApi = '/prj/projectAutoRule/getProjectAutoRuleModelFileUrl',
  completePrjApi = '/prj/projectInfo/complete',
  restartPrjApi = '/prj/projectInfo/restart',
  getOrganizationApi = '/crm/agencyInfo/invoice',
  getStatisticsByPrjIdApi = '/prj/projectInfo/statisticsByPrjId/',
  updataEntityColumnsApi = '/sys/sysListHeader',
  createReport = '/spp/asyncReportTask/save',
  downLoadReport = '/spp/asyncReportTask/downLoadReport',
  getReportSetting = '/spp/asyncReportTask/getBaseInfo',
  getReportTemplateList = '/spp/reportTemplate/list',
  addReportContent = '/spp/asyncReportTask/addBizParameters',
  getReportStatementList = '/spp/asyncReportTask/statement/list',
  getReportStatementListNew = '/spp/asyncReportTask/statements',
  getReportQrCaseList = '/spp/asyncReportTask/questionnaire/list',
  getReportVisitList = '/spp/asyncReportTask/visit/list',
  getReportInfoList = '/spp/asyncReportTask/infoVideo/list',
  batchDelReportContent = '/spp/asyncReportTask/delBizParameters',
  getReportFormList = '/spp/asyncReportTask/questionnaires',
  getReportQuestionAnalysisList = '/spp/asyncReportTask/questionnaire/analysis',
  getReportQuestionSetting = '/spp/asyncReportTask/questionnaires/analysis/chartParam',
  getPrjHasCreateBillApi = '/prj/projectInfo/remove/checkBill',
  getTaskHasCreateBillApi = '/spp/task/checkTaskBillDelete/',
  getExecutorAutoRule = '/prj/projectExecutorAutoRule/queryByPrjId',
  editExecutorAutoRule = '/prj/projectExecutorAutoRule/edit',
  queryPredictExecutorNumber = '/prj/projectExecutorAutoRule/queryExecutorCountByAutoRule',
  prjDeliveryRoleTree = '/prj/projectDeliveryRuleDict/tree',
  prjDeliveryRoleList = '/prj/projectDeliveryRule/list',
  prjDeliveryRuleSave= '/prj/projectDeliveryRule/addOrEdit',
  projectDeliveryRule = '/prj/projectDeliveryRule/task/rule',
  taskContentToReportApi = '/spp/asyncReportTask/addTasks',
  prjUserInfoByType = '/spp/industrial/projectInfo/getUserInfo',
  prjRetractFetchApi = '/prj/projectInfo/revoke',
  groupListApi = '/prj/projectGroup/treeSelect',
  generateTemplateProject = '/prj/projectInfo/makeDataChange',
  getTemplateInfo = '/prj/businessTemplateInfo/listNoPage',
  getTemplateIndustryList = '/prj/businessTemplateInfo/industry/list',
  getContractInfo = '/spp/contractInfo/listNoPage',
  getPriceSyncInfo = '/spp/paymentTaskPrice/agency/getSyncStatus',
  fillProjectForm = '/prj/projectInfo/fillProjectFormByAi',
  reportTaskType = '/spp/asyncReportTask/delivery/count',
  reportDeliveryList = '/spp/asyncReportTask/delivery/Page',
  addDelivery = '/spp/asyncReportTask/addDelivery',
  getReportDeliveryDetail = '/spp/asyncReportTask/detail/delivery/get',
  getProjectModelFileUrl = '/prj/projectInfo/getProjectModelFileUrl',
  importProject = '/spp/asyncTask/project/import',
  makeProjectReport = '/spp/statementInfo/makeProjectReport',
}

// 获取项目信息详情
export function getProjectInfo(params) {
  return defHttp.get({url: Api.getProjectInfo + params.id,params}, { successMessageMode: 'none' })
}

// 获取项目基本信息
export function getProjectBaseInfoApi(params) {
  return defHttp.get({url: Api.projectBaseInfo, params}, { successMessageMode: 'none' })
}


// 驳回项目
export function rejectProject(params) {
  return defHttp.put({url: Api.rejectProject + '?id=' + params.id + '&comment=' + params.comment},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

// 通过项目
export function confirmProject(params) {
  return defHttp.put({url: Api.confirmProject+ '?id=' + params.id},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
// 通过项目
export function confirmNewProject(params) {
  return defHttp.post({url: Api.newConfirmProject,params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function listProject(params) {
  if (params.createTime) {
    let timeValue = params.createTime
    if (!Array.isArray(timeValue)) {
      timeValue = timeValue.split(',')
    }
    const [startTime, endTime]: string[] = timeValue;
    params['createStartTime'] = dateUtil(startTime).format('YYYY-MM-DD') + ' 00:00:00';
    params['createEndTime'] = dateUtil(endTime).format('YYYY-MM-DD') + ' 23:59:59';
  }
  return defHttp.post({url: Api.listProject, params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function getAttachments(params) {
  return defHttp.get({url: Api.getAttachments, params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function getPlanByPrjId(params) {
  return defHttp.get({url: Api.getPlanByPrjId + "?prjId=" + params.prjId},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function getStatisticsByPrjId(id) {
  return defHttp.get({url: Api.getStatisticsByPrjIdApi + id},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function fileToBase64(params) {
  return defHttp.get({url: Api.fileToBase64, params},{ successMessageMode: 'none' })
}


export const deletePrjApi = (params, handleSuccess) => {//删除项目
  Modal.confirm({
    title: '删除项目',
    content: '确定删除当前项目？',
    icon: () => createVNode(ExclamationCircleOutlined, {style: {}}),
    okText: '确定',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      return defHttp.delete({ url: Api.deletePrj+ "?id=" + params.id , params }, {successMessageMode: 'none'}).then(() => {
        handleSuccess();
      });
    }
  })
}

export const deleteProjectFetch = (params) => {
  return defHttp.delete({ url: Api.deleteProject+ "?id=" + params.id , params }, {successMessageMode: 'none'})
}

export const checkDeleteAllowFetch = (params) => {
  return defHttp.get({url: Api.checkDeleteAllowApi,params},{ successMessageMode: 'none' })
}

export const copyPrjApi = (params, handleSuccess) => {//复制项目
  Modal.confirm({
    title: '复制',
    content: '确定复制当前项目？',
    okText: '确定',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      return defHttp.post({ url: Api.copyPrj + "?id=" + params.id , params }, {successMessageMode: 'none'}).then(() => {
        handleSuccess();
      });
    }
  })
}

export function getSysArea(params) {
  return defHttp.get({url: Api.sysAreaList,params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
export function enterpriseList(params = {}) {
  return defHttp.get({url: Api.enterpriseList, params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
// 查询当前企业合作结构及合作机构子公司
export function getEnterpriseInfoWithSub(params = {}) {
  return defHttp.get({url: Api.enterpriseInfoWithSub, params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
// 指定企业id查询企业基本信息及其子公司
export function getEnterpriseInfoWithSubById(params = {}) {
  return defHttp.get({url: Api.enterpriseInfoWithSubById, params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
export function handShakingEnterpriseList() {
  return defHttp.get({url: Api.handShakingEnterpriseList},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function getServerList() {
  return defHttp.get({url: Api.serverList},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function getServerInfo(params) {
  return defHttp.get({url: Api.serverInfo,params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
export function getServerUserData(params) {
  return defHttp.get({url: Api.getServerUserData,params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function getPrjCode(params) {
  return defHttp.get({url: Api.getPrjCode,params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function addPrjStep1(params) {
  return defHttp.post({url: Api.addPrjStep1,params},{ successMessageMode: 'none' })
}
export function addPrjStep2(params) {
  return defHttp.post({url: Api.addPrjStep2,params},{ successMessageMode: 'none' })
}

export function getPrjPermision(params) {
  return defHttp.get({url: Api.getPrjPermision + params.id, params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}

export function savePrj(params) {
  return defHttp.put({url: Api.savePrj,params},{ successMessageMode: 'none' })

}
export function submitPrj(params) {
  return defHttp.post({url: Api.submitPrj,params},{ successMessageMode: 'none' })

}
// 锁定项目结算单
export function lockPrjStatementInfo(params) {
  return defHttp.get({url: Api.lockPrjStatementInfo, params, timeout:180 * 1000},{ successMessageMode: 'none' })
}
// 解锁项目结算单
export function unLockPrjStatementInfo(params) {
  return defHttp.get({url: Api.unLockPrjStatementInfo,params, timeout:180 * 1000},{ successMessageMode: 'none' })
}
// 项目-结算单信息
export function getProjectDelivery(params) {
  return defHttp.get({url: Api.projectDeliveryInfo,params})
}
// 锁定结算单
export function createStatementInfo(params) {
  return defHttp.get({url: Api.createStatementInfo,params},{ successMessageMode: 'none' })
}
// 全量制作结算单 查询数据
export function getAllDelivery(params) {
  return defHttp.get({url: Api.queryAllStatement, params})
}

// 新建结算单-查询交付物
export function queryDeliveryListByStatementApi(params) {
  return defHttp.post({url: Api.queryDeliveryListByStatement, params})
}

// 新建结算单-查询医生列表
export function queryStatementByDoctorPageApi(params) {
  return defHttp.post({url: Api.queryStatementByDoctorPage, params})
}

// 新建结算单-查询执行方列表
export function queryStatementByOutsiderPageApi(params) {
  return defHttp.post({url: Api.queryStatementByOutsourcerPage, params})
}

// 生成结算单
export function submitStatementsByAll(params) {
  return defHttp.post({url: Api.submitStatements,params})
}
// 结算单更新交付物数量
export function updateDeliveryCount(params) {
  return defHttp.post({url: Api.updateDeliveryCount,params,timeout:180 * 1000},{ successMessageMode: 'none' })
}

// 结算单根据数量查询金额
export function getDeliveryAmount(params){
  return defHttp.post({url: Api.getDeliveryAmount,params},{ successMessageMode: 'none' })
}
// 查询某个类型下交付物的计算过程
export function getDeliveryCalculateRule(params) {
  return defHttp.get({url: Api.deliveryCalculateRule,params})
}
// 获取企业纳税信息列表
export function getEnterpriseTaxList(params) {
  return defHttp.get({url: Api.enterpriseTaxList,params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
export function fillEnterpriseTaxInfo(params) {
  return defHttp.get({url: Api.fillEnterpriseTaxInfo, params},{ errorMessageMode: 'none', successMessageMode: 'none' })
}
export function initiatorManagerList(params) {
  return defHttp.get({url: Api.initiatorManagerApi,params},{ successMessageMode: 'none' })
}
//工业端统计各类交付物数量
export function industrialDeliveryCount(params) {
  return defHttp.get({url: Api.industrialDeliveryCount,params},{ successMessageMode: 'none' })
}

export function changeInitiatorManagerFetch(params) {
  return defHttp.put({url: Api.changeInitiatorManagerApi,params},{})
}

// 添加项目管理人员
export function addPrjManagerFetch(params) {
  return defHttp.post({ url: Api.addPrjManagerApi, params }, { successMessageMode: 'none' });
}

// 查询项目管理人员列表
export function getPrjManagerList(params) {
  return defHttp.get({ url: Api.prjManagerUserRoleListApi, params });
}

// 移除项目管理人员
export function deletePrjManagerFetch(params) {
  return defHttp.delete({ url: Api.deletePrjManagerApi, params }, { joinParamsToUrl: true, successMessageMode: 'none' });
}

// 批量移除项目管理人员
export function deletePrjManagerBatchFetch(params) {
  return defHttp.delete({ url: Api.deletePrjManagerBatchApi, params }, { joinParamsToUrl: true, successMessageMode: 'none' });
}

// 查询项目管理人员功能权限
export function queryPrjManagerFunFetch(params) {
  return defHttp.get({ url: Api.queryPrjManagerFunApi, params });
}

// 查询当前用户在某项目下的管理人员功能权限
export function queryMyPrjManagerAuthFetch(params) {
  return defHttp.get({ url: Api.myPrjAuthListApi, params });
}

// 保存项目管理人员功能权限
export function addPrjManagerFunFetch(params) {
  return defHttp.post({ url: Api.addPrjManagerFunApi, params }, { successMessageMode: 'none' });
}

// 查询项目管理人员数据权限
export function queryPrjManagerDataRoleFetch(params) {
  return defHttp.get({ url: Api.queryPrjManagerDataRoleApi, params });
}

// 保存项目管理人员数据权限
export function addPrjManagerDataRoleFetch(params) {
  return defHttp.post({ url: Api.addPrjManagerDataRoleApi, params }, { successMessageMode: 'none' });
}

//获取项目规则
export function getPrjSetingDataFetch(params) {
  return defHttp.get({url: Api.getPrjSettingApi + params.id})
}
//保存项目设置自动规则
export function savePrjSetingDataFetch(params) {
  return defHttp.post({url: Api.savePrjSettingApi, params})
}
//获取地区任务下的交付物总金额
export function getPrjAmountFetch(params) {
  return defHttp.post({url: Api.getPrjAmountFetchApi, params}, { successMessageMode: 'none' })
}

//获取项目字段信息是否可编辑
export function getPrjFieldDisableFetch(params) {
  return defHttp.get({url: Api.getPrjFieldDisableApi, params}, { successMessageMode: 'none' })
}

//获取项目操作日志
export function getPrjEntityDataLogFetch(params) {
  return defHttp.get({url: Api.getPrjEntityDataLogApi, params}, { successMessageMode: 'none' })
}


// 获取企业纳税信息列表
export const exportVisitTaskData = '/prj/projectInfo/exportVisitData'
// 获取交付物修改的数量
export function getDeliveryListNumApi(params){
  return defHttp.post({url: Api.deliveryListNum,params},{ successMessageMode: 'none' })
}
// 获取交付物数量集合的总金额
export function getDeliveryListAmountApi(params){
  return defHttp.post({url: Api.deliveryListAmount,params},{ successMessageMode: 'none' })
}

// 更新交付物集合的数量
export function updateDeliveryListCountApi(params) {
  return defHttp.post({url: Api.updateDeliveryListCount,params,timeout:180 * 1000},{ successMessageMode: 'none' })
}
// 查询交付物价格区间
export function getDeliveryPriceRangeApi() {
  return defHttp.get({url: Api.deliveryPriceRange},{ successMessageMode: 'none' })
}
// 查询交付物销售价是否在价格区间
export function getDeliveryPriceCheckApi(params) {
  return defHttp.post({url: Api.deliveryPriceCheck, params},{ successMessageMode: 'none' })
}
// 查询交付物采购价是否在价格区间
export function getDeliveryActualUnitPriceCheckApi(params) {
  return defHttp.post({url: Api.deliveryActualUnitPriceCheck, params},{ successMessageMode: 'none' })
}
// 修改价格提交
export function updateDeliveryPriceApi(params) {
  return defHttp.post({url: Api.updateDeliveryPrice,params},{ successMessageMode: 'none' })
}

// 结算单-获取交付物的数量
export const getDeliveryCountByFilterApi = (params) => {
  return defHttp.post({url: Api.queryDeliveryCountByFilter, params},{ successMessageMode: 'none' })
}

// 结算单-更新交付物的数量
export const updateDeliveryCountByFilterApi = (params) => {
  return defHttp.post({url: Api.updateDeliveryCountByFilter, params},{ successMessageMode: 'none' })
}
  
// 查询会议执行人金额
export function getMeetingExecutorPriceApi(params) {
  return defHttp.get({url: Api.meetingExecutorPrice,params},{ successMessageMode: 'none' })
}

// 修改会议执行人金额
export function updateMeetingDeliveryPriceApi(params) {
  return defHttp.post({url: Api.updateMeetingDeliveryPrice,params},{ successMessageMode: 'none' })
}

// 导入自动化规则
export function importAutoRule(params, callback) {
  return defHttp.uploadFile({url: Api.importProjectAutoRuleApi, timeout: 180 * 1000}, params, callback)
}

// 获取下载自动化规则模板的url
export function getAutoRuleTemplateUrl() {
  return defHttp.get({url: Api.getAutoRuleTemplateUrlApi},{ successMessageMode: 'none' })
}

//项目完成
export function completePrjFetch(params) {
  return defHttp.put({url: Api.completePrjApi +'?id=' + params.id },{ successMessageMode: 'none' })
}
//项目重启
export function restartPrjFetch(params) {
  return defHttp.put({url: Api.restartPrjApi +'?id=' + params.id},{ successMessageMode: 'none' })
}


//结算单获取机构信息
export function getOrganizetionInfoFetch(params) {
  return defHttp.get({url: Api.getOrganizationApi + '/' + params.prjId}, { successMessageMode: 'none' })
}


//结算单获取机构信息
export function updataEntityColumnsFetch(params) {
  return defHttp.put({url: Api.updataEntityColumnsApi, params}, { successMessageMode: 'none' })
}

//上传多文件识别发票
export const invoiceNoApi = 'extend/ticket/upload2Discern'

// 生成结题报告
export function createReportApi(params) {
  return defHttp.post({url: Api.createReport,params},{ successMessageMode: 'none' })
}

export function downLoadReportApi(params) {
  return defHttp.post({url: Api.downLoadReport,params},{ successMessageMode: 'none' })
}
// 查询结题报告
export function getReportSettingApi(params) {
  return defHttp.get({url: Api.getReportSetting,params},{ successMessageMode: 'none' })
}

// 获取结题报告模板
export function getReportTemplateListApi(params) {
  return defHttp.get({url: Api.getReportTemplateList,params},{ successMessageMode: 'none' })
}
// 结题报告添加内容
export function addReportContentApi(params) {
  return defHttp.post({url: Api.addReportContent,params},{ successMessageMode: 'none' })
}

export function getReportStatementListApi(params) {
  return defHttp.get({url: Api.getReportStatementList,params},{ successMessageMode: 'none' })
}
export function getReportStatementListNewApi(params) {
  return defHttp.post({url: Api.getReportStatementListNew,params},{ successMessageMode: 'none' })
}

export function getReportQrCaseListApi(params) {
  return defHttp.get({url: Api.getReportQrCaseList,params},{ successMessageMode: 'none' })
}

export function getReportVisitListApi(params) {
  return defHttp.get({url: Api.getReportVisitList,params},{ successMessageMode: 'none' })
}

export function getReportInfoListApi(params) {
  return defHttp.get({url: Api.getReportInfoList,params},{ successMessageMode: 'none' })
}

export function batchDelReportContentApi(params) {
  return defHttp.post({url: Api.batchDelReportContent,params},{ successMessageMode: 'none' })
}

// 获取结题报告表单下拉列表
export function getReportFormListApi(params) {
  return defHttp.get({url: Api.getReportFormList,params},{ successMessageMode: 'none' })
}

// 获取结题报告问卷题目数据
export function getReportQuestionAnalysisListApi(params) {
  return defHttp.get({url: Api.getReportQuestionAnalysisList,params, timeout: 300 * 1000},{ successMessageMode: 'none' })
}

// 获取结题报告问卷题目数据
export function getReportQuestionSettingApi(params) {
  return defHttp.get({url: Api.getReportQuestionSetting,params},{ successMessageMode: 'none' })
}

export function hasCreatedBillInfo(params) {
  let url = ''
  if (params?.bizType == 'project' || params?.bizType == 'plan') {
    url = Api.getPrjHasCreateBillApi
  } else if (params?.bizType == 'task') {
    url = Api.getTaskHasCreateBillApi + `${ params.id }`
  }
  return url ? defHttp.get({url ,params},{ successMessageMode: 'none' }) : false;
}

// 查询项目执行人自动规则
export function getExecutorAutoRule(params) {
  return defHttp.get({url: Api.getExecutorAutoRule, params},{ successMessageMode: 'none' })
}

// 更改项目执行人自动规则
export function editExecutorAutoRule(params) {
  return defHttp.put({url: Api.editExecutorAutoRule, params},{ successMessageMode: 'none' })
}

// 查询项目交付物规则Tree
export function getDeliveryRuleTree(params) {
  return defHttp.get({url: Api.prjDeliveryRoleTree, params},{ successMessageMode: 'none' })
}

// 查询项目交付物规则
export function getDeliveryRuleListApi(params) {
  return defHttp.get({url: Api.prjDeliveryRoleList, params},{ successMessageMode: 'none' })
}

// 查询项目交付物规则
export function saveDeliveryRuleApi(params) {
  return defHttp.post({url: Api.prjDeliveryRuleSave, params},{ successMessageMode: 'none' })
}

// 查询预计执行人数
export function queryPredictExecutorNumber(params) {
  return defHttp.post({url: Api.queryPredictExecutorNumber, params },{ successMessageMode: 'none', errorMessageMode: 'none' })
}

// 查询项目交付物自动化规则
export function getProjectDeliveryRule(params) {
  return defHttp.get({url: Api.projectDeliveryRule, params},{ successMessageMode: 'none' })
}

// 项目报告添加任务
export function addTaskContentToReport(params) {
  return defHttp.post({url: Api.taskContentToReportApi, params, timeout: 300 * 1000},{ successMessageMode: 'none' })
}

//查询项目负责人
export function getPrjUserInfoByType(params) {
  return defHttp.get({url: Api.prjUserInfoByType, params},{ successMessageMode: 'none' })
}

//项目撤回
export function prjRetractFetch(params) {
  return defHttp.get({url: Api.prjRetractFetchApi, params},{ successMessageMode: 'none' })
}

// 查询项目交付物自动化规则
export function getGroupDataList(params) {
  return defHttp.get({ url: Api.groupListApi,params },{ successMessageMode: 'none' })
}

// 生成项目临时变更id
export const generateTemplateProjectApi= (params) => {
  return defHttp.get({url: Api.generateTemplateProject, params},{ errorMessageMode: 'none',successMessageMode: 'none' });
}

// 获取项目行业模板列表
export const getTemplateIndustryListApi = () => {
  return defHttp.get({url: Api.getTemplateIndustryList},{ errorMessageMode: 'none',successMessageMode: 'none' });
}

// 获取项目企业模板列表
export const getTemplateInfoApi= () => {
  return defHttp.get({url: Api.getTemplateInfo},{ errorMessageMode: 'none',successMessageMode: 'none' });
}

// 获取合同列表
export const getContractInfoApi = (params) => {
  return defHttp.get({url: Api.getContractInfo, params},{ errorMessageMode: 'none',successMessageMode: 'none' });
}

// 获取项目发起方同步价格信息
export const getPriceSyncInfoApi = (params) => {//获取项目发起方同步价格信息
  return defHttp.get({url: Api.getPriceSyncInfo, params},{ errorMessageMode: 'none',successMessageMode: 'none' })
}

export const fillProjectFormByAiApi = (params) => {//获取项目变更模板列表
  return defHttp.post({url: Api.fillProjectForm, params, timeout: 300 * 1000},{ successMessageMode: 'none' })
}

// 下载报告-获取任务类型列表
export const getReportTaskTypeApi = (params) => {
  return defHttp.get({url: Api.reportTaskType, params},{ errorMessageMode: 'none',successMessageMode: 'none' })
}

// 下载报告-获取交付物列表
export const getReportDeliveryListApi = (params) => {
  return defHttp.post({url: Api.reportDeliveryList, params}, {successMessageMode: 'none'});
}

// 下载报告-添加交付物
export const addReportDeliveryApi = (params) => {
  return defHttp.post({url: Api.addDelivery, params}, {successMessageMode: 'none'});
}

// 下载报告-获取交付物详情
export const getReportDeliveryDetailApi = (params) => {
  return defHttp.get({url: Api.getReportDeliveryDetail, params}, {successMessageMode: 'none'});
}

export const getImportTemplateUrl = () => {
  return defHttp.get({ url: Api.getProjectModelFileUrl }, { errorMessageMode: 'none', successMessageMode: 'none' });
}

export const importProjectApi = Api.importProject

export const makeProjectReportApi = (params) => {
  return defHttp.post({url: Api.makeProjectReport, params});
};
